import type { CmsLink } from '@/services/cms/models/CmsLink';
import type { CmsMenuItem } from '@/services/cms/models/CmsNavigationItem';

function extractUrl(link: CmsLink | CmsMenuItem | string): string | undefined {
    if (!link) {
        return undefined;
    }
    if (typeof link === 'string') {
        return link;
    }
    if (typeof link === 'object' && 'url' in link) {
        return link.url;
    }
    return link?.href;
}

export function urlForCmsLink(link: CmsLink | CmsMenuItem | string): string {
    const url = extractUrl(link);
    if (!url || url === 'home' || url === '/') {
        return '/home';
    }
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url)) {
        return url;
    }
    return url.startsWith('/') ? url : `/${url}`;
}
